import React, { useEffect, useState } from "react";
import { SliderCustom } from "../../../styled-components/CustomStyles.style";
import CustomImageContainer from "../../CustomImageContainer";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { ProductsThumbnailsSettings } from "./ProductsThumbnailsSettings";
import { Box, Stack } from "@mui/system";
import CustomMagnifier from "../../CustomMagnifier";
import {
  IconButton,
  NoSsr,
  styled,
  useTheme,
} from "@mui/material";

import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

const ChildrenImageWrapper = styled(Box)(({ theme, index, image_index }) => ({
  cursor: "pointer",
  border: index === image_index && `2px solid ${theme.palette.primary.main}`,
  borderRadius: ".5rem",
  boxSizing: "border-box",
  height: "100%",
  width: "100%",
  filter: "drop-shadow(0px 3.41085px 8.52713px rgba(0, 0, 0, 0.1))",
  position: "relative",
}));

const ProductImageView = ({
  productImage,
  productThumbImage,
  imageBaseUrl,
  configData,
  addToWishlistHandler,
  removeFromWishlistHandler,
  isWishlisted,
}) => {
  const [preViewImage, setPreViewImage] = useState(null);
  const [imageIndex, setImageIndex] = useState(0);
  const theme = useTheme();
  const tempProduct = productImage;
  useEffect(() => {
    setPreViewImage(tempProduct);
  }, [productImage, tempProduct]);

  const handleClick = (item, index) => {
    setPreViewImage(`${configData?.base_urls?.item_image_url}/${item}`);
    setImageIndex(index);
  };
  const borderColor = theme.palette.primary.main;
  return (
    <Stack justifyContent="flex-start" spacing={2} width="100%">
      <NoSsr>
        <Stack sx={{ position: "relative" }}>
          <Stack
            position="absolute"
            right="10px"
            top={{ xs: "48px", sm: "48px", md: "10px" }}
            zIndex="99"
          >
            {isWishlisted ? (
              <IconButton
                sx={{ backgroundColor: (theme) => theme.palette.neutral[300] }}
                onClick={(e) => removeFromWishlistHandler(e)}
              >
                <FavoriteIcon
                  style={{ width: "15px", height: "15px", color: borderColor }}
                />
              </IconButton>
            ) : (
              <IconButton
                sx={{ backgroundColor: (theme) => theme.palette.neutral[300] }}
                onClick={(e) => addToWishlistHandler(e)}
              >
                <FavoriteBorderIcon
                  style={{ width: "15px", height: "15px", color: borderColor }}
                />
              </IconButton>
            )}
          </Stack>
          <CustomMagnifier
            className="magnify-container"
            src={preViewImage}
            alt="image"
            style={{
              height: "324px",
              border: `1px solid rgba(27, 127, 237, 0.1)`,
              borderRadius: "10px",
            }}
            mgWidth={200}
            mgHeight={200}
            zoomFactor={1.5}
          />
        </Stack>
      </NoSsr>

      {productThumbImage?.length > 0 && (
        <SliderCustom
          sx={{
            margin: {
              xs: "58px 0px 0px 0px !important",
              sm: "40px 0px 0px 0px !important",
              md: "10px 0px 0px 0px !important",
            },
          }}
        >
          <Slider {...ProductsThumbnailsSettings}>
            {productThumbImage?.map((item, index) => {
              return (
                <ChildrenImageWrapper
                  key={index}
                  onClick={() => handleClick(item, index)}
                  index={index}
                  image_index={imageIndex}
                >
                  <CustomImageContainer
                    src={`${imageBaseUrl}/${item}`}
                    width="100%"
                    height="100%"
                    objectFit="cover"
                    borderRadius=".5rem"
                  />
                </ChildrenImageWrapper>
              );
            })}
          </Slider>
        </SliderCustom>
      )}
    </Stack>
  );
};

export default ProductImageView;
